import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChooseTopologyItemComponent } from './choose-topology-item/choose-topology-item.component';
import {NetworkDiagramModule} from '../network-diagram/network-diagram.module';
import {ChooseTopologyItemContainerComponent} from './choose-topology-item-container/choose-topology-item-container.component';
import {InfraModule} from 'ac-infra';
import {MaterialModule} from '../../material.module';
import {ContextMenuModule} from '@perfectmemory/ngx-contextmenu';
import {FormsModule} from '@angular/forms';

@NgModule({
  declarations: [
    ChooseTopologyItemComponent,
    ChooseTopologyItemContainerComponent
  ],
  exports: [
    ChooseTopologyItemComponent,
    ChooseTopologyItemContainerComponent
  ],
  imports: [
    CommonModule,
    InfraModule,
    ContextMenuModule,
    NetworkDiagramModule,
    MaterialModule,
    FormsModule
  ]
})
export class ChooseTopologyItemModule { }
